import React from 'react';
import PlayerLink from '../../../components/PlayerLink';
import { dynastyTokens } from '../../../services/colorService';
import { fmtSalary, isPitcher, getPlayerCategoryStats, positionLabel } from './optimizerUtils';
import OptimizerStatGrid from './OptimizerStatGrid';

const colors = dynastyTokens.colors;

const OptimizerPlayerTile = ({ player, posStyle, dotColor, isActive, onClick, categories }) => {
  const stats = getPlayerCategoryStats(player, categories);

  return (
    <div
      onClick={() => onClick(player)}
      style={{
        position: 'absolute',
        transform: 'translateX(-50%)',
        ...posStyle,
        background: `${colors.neutral[800]}f2`,
        border: `1px solid ${isActive ? 'rgba(234,179,8,0.7)' : colors.neutral[700]}`,
        borderRadius: 4,
        padding: '7px 10px',
        width: 192,
        cursor: 'pointer',
        zIndex: 10,
        transition: 'border-color 0.15s',
      }}
      onMouseEnter={e => { if (!isActive) e.currentTarget.style.borderColor = 'rgba(234,179,8,0.5)'; }}
      onMouseLeave={e => { if (!isActive) e.currentTarget.style.borderColor = colors.neutral[700]; }}
    >
      {/* Indicator dot */}
      <div style={{
        position: 'absolute', top: -3, right: -3,
        width: 8, height: 8, borderRadius: '50%',
        background: dotColor,
      }} />
      {/* Line 1: Name + Salary */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ fontSize: 12, fontWeight: 600, color: colors.white, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', flex: 1, minWidth: 0 }}>
          <PlayerLink mlbId={player.ids?.mlb} name={player.info?.full_name || '—'} style={{ color: colors.white, fontSize: 12, fontWeight: 600 }} />
        </div>
        <span style={{ fontSize: 11, color: colors.neutral[400], marginLeft: 6, flexShrink: 0 }}>{fmtSalary(player)}</span>
      </div>
      {/* Line 2: POS · TEAM */}
      <div style={{ fontSize: 10, color: colors.neutral[400], marginTop: 1 }}>
        {positionLabel(player)} · {player.info?.mlb_team || '—'}
      </div>
      {/* Stats: shared 2×3 grid (Item 3) */}
      <OptimizerStatGrid stats={stats} gap={10} marginTop={4} />
    </div>
  );
};

export default OptimizerPlayerTile;
